import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ComplementBuilder } from '../../models/builders/complement-builder';
import { ComplementsRequestInterface } from '../../models/request/complements-request.interface';
import { Complement } from '../../models/complement';
import { ComplementTypeBuilder } from '../../models/builders/complement-type-builder';

const createComplementBody = (complement: Complement) => (
  {
    code: complement.code,
    name: complement.name,
    price: complement.price,
    weight: complement.weight,
    description: complement.description,
    needSerialNumber: complement.needSerialNumber,
    complementTypeHash: complement.complementType,
    brandHash: complement.brand,
  }
);

@Injectable()
export class ComplementApiService {
  private apiUrl: string;

  constructor(
    private httpClient: HttpClient
  ) {
    this.apiUrl = `${environment.apiUrl}complements`;
  }

  getComplement(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`)
     .pipe(
       map(ComplementBuilder.fromJson)
    );
  }

  getComplements() {
    return this.httpClient.get(this.apiUrl).pipe(map(ComplementBuilder.fromJsonList));
  }

  createComplement(complement: Complement) {
    return this.httpClient.post(`${this.apiUrl}`, createComplementBody(complement)).pipe(
      map(ComplementBuilder.fromJson)
    );
  }

  updateComplement(complement: Complement) {
    return this.httpClient.put(`${ this.apiUrl }/${ complement.hash }`, createComplementBody(complement));
  }

  deleteComplement(complementHash: string) {
    return this.httpClient.delete(`${ this.apiUrl }/${ complementHash }`);
  }

  getFilteredComplements(request: ComplementsRequestInterface)  {
    let params = new HttpParams();
    params = params.append('page', request.page.toString())
                   .append('itemsPerPage', request.itemsPerPage.toString())
                   .append('sortField', request.sortField)
                   .append('reverse', (!!request.reverse).toString());
    if (request.code) {
      params = params.append('code', request.code);
    }
    if (request.name) {
      params = params.append('name', request.name);
    }

    return this.httpClient.get(`${this.apiUrl}/filter`, { params: params })
      .pipe(
        map(this.mapData)
      );
  }

  getComplementTypes() {
    return this.httpClient.get(`${this.apiUrl}/complement-types`).pipe(map(ComplementTypeBuilder.fromJsonList));
  }

  private mapData = (data) => {
    data.complements = ComplementBuilder.fromJsonList(data.complements);
    return data;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/services/api/complement-api.service.ts